import { render, staticRenderFns } from "./PotentialDressForClientModal.vue?vue&type=template&id=74b85ecd&scoped=true"
import script from "./PotentialDressForClientModal.vue?vue&type=script&lang=js"
export * from "./PotentialDressForClientModal.vue?vue&type=script&lang=js"
import style0 from "./PotentialDressForClientModal.vue?vue&type=style&index=0&id=74b85ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b85ecd",
  null
  
)

export default component.exports